import { useGetAuthUser } from "./get-user";

export function useIsSuperAdmin(): {
  isLoading: boolean;
  isSuperAdmin: boolean;
} {
  const { data, isSuccess, isLoading } = useGetAuthUser();
  if (isSuccess) {
    const cognitoUserGroups = (data.payload["cognito:groups"] ||
      []) as string[];

    return {
      isLoading,
      isSuperAdmin: cognitoUserGroups.includes("SUPER_ADMIN"),
    };
  }

  return { isLoading, isSuperAdmin: false };
}
